import { useNavigate } from "react-router-dom";
import LayoutMain from "../../shared/layouts/LayoutMain/LayoutMain";
import { BCButton } from "../../shared/styled/global.styled";

const Home = () => {

  const navigate = useNavigate();


  return (
    <LayoutMain idPage="Home">
      <div className="title-options bc-margin-top-3 bc-card-rounded">
        <div className="bc-row">
          <div className="bc-col-6">
            <h2>Bienvenidos a DyForm</h2>
          </div>
          <div className="bc-col-6">
            <div className="bc-flex bc-justify-content-flex-end">
              <BCButton
                type="button"
                className="bc-button-primary bc-button-small"
                onClick={() => navigate("/formularios/crear")}
              >
                Comencemos
              </BCButton>
            </div>
          </div>
        </div>
        <h4>
          Autonomía y autoservicio para recolectar información de formularios
        </h4>
        <p>
          <strong>DyForm</strong> es la herramienta que te permite crear
          formularios de manera rapida para la centralización en la bases de
          datos de la organización
        </p>
      </div>
    </LayoutMain>
  );
};

export default Home;
